<template>
  <div class="app">
    <component :is="component" :config="config" />
  </div>
</template>

<script>
import NewsSearch from "./NewsSearch.vue";
import PortfolioSearch from "./PortfolioSearch.vue";
import TeamSearch from "./TeamSearch.vue";

export default {
  name: "App",
  components: {
    NewsSearch,
    PortfolioSearch,
    TeamSearch,
  },
  props: {
    component: {
      type: String,
      default: "",
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>
